import { FormGroup } from '@angular/forms';
import { WorldpayForm } from './worldpay-form.interface';

export type WorldpayFormValue = ReturnType<
  FormGroup<WorldpayForm>['getRawValue']
>;
